<template>
  <div class="m-about-us">
    <!-- <img class="m-page-banner" src="../../assets/images/about_banner.jpg" alt=""> -->
    <div class="m-page-banner"></div>
    <div class="m-about-introduce" id="introduce">
      <div class="module-title">企业简介</div>
      <div class="introduce-content">
        <p>我们成立于2001年，以先进的教育理念为指导，以优质的教育教学为依托，专注于探索信息技术与教育教学的深度融合，为全国中小学校提供课堂模式改革和应用、教师专业发展、教研能力创新、优质教育共享、学生全面发展的全过程智慧教育解决方案，是一个拥有深厚教育底蕴的教育科技品牌。</p>
        <p>自创立以来，始终围绕“让更多的孩子得到更好的教育”使命，已为全国多地教育主管部门、4000多所学校提供了全过程智慧教育解决方案，累计30多万教师、300多万学生受益，为推动中国教育的优质均衡发展、教学质量提升及教师专业发展贡献了力量。</p>
      </div>
    </div>
    <div class="m-about-connect" id="connect">
      <div class="module-title">联系方式</div>
      <div class="connect-content">
        <div class="connect-item">
          <img class="connect-item-img" src="../../assets/images/support_phone.png" alt="">
          <div>
            <p class="connect-item-title">商务合作：</p>
            <p class="connect-item-content" style="margin-top:.18rem;">400-661-6666</p>
          </div>
        </div>
        <div class="connect-item">
          <img class="connect-item-img" src="../../assets/images/email.png" alt="">
          <div>
            <p class="connect-item-title">媒体合作：</p>
            <p class="connect-item-content" style="margin-top:.18rem;">010-82025511</p>
          </div>
        </div>
      </div>
      <img class="connect-img" src="../../assets/images/mImg/about.png" alt="">
    </div>
  </div>
</template>
<script>
import scrollreveal from 'scrollreveal'
export default {
  mounted() {
    if (this.$route.query.id) {
      let id  = this.$route.query.id
      let scrollDom = document.getElementById(id)
      document.documentElement.scrollTop = document.body.scrollTop = scrollDom.offsetTop - 140
    }
    this.$nextTick(() => {
      let that = this
      setTimeout(() => {
        that.setAnimation()
      }, 100)
    })
  },
  methods: {
    // 动画
    setAnimation() {
      scrollreveal().reveal('.m-about-us .module-title', {
        duration: 1200, //动画的时长
        origin: 'bottom', //动画开始的位置，'bottom', 'left', 'top', 'right'
        reset: true, //回滚的时候是否再次触发动画
        mobile: true, //在移动端是否使用动画
        distance: '40px', //滚动的距离，单位可以用%，rem等
        easing: 'ease-in-out'
      });
      scrollreveal().reveal('.m-about-us .introduce-content', {
        duration: 1200,
        origin: 'bottom',
        reset: true,
        mobile: true,
        distance: '40px',
        easing: 'ease-in-out'
      });
      scrollreveal().reveal('.m-about-us .connect-item-img', {
        duration: 1200,
        origin: 'bottom',
        reset: true,
        mobile: true,
        distance: '40px',
        easing: 'ease-in-out'
      });
      scrollreveal().reveal('.m-about-us .connect-item-title', {
        duration: 1200,
        origin: 'bottom',
        reset: true,
        mobile: true,
        distance: '40px',
        easing: 'ease-in-out'
      });
      scrollreveal().reveal('.m-about-us .connect-item-content', {
        duration: 1200,
        origin: 'bottom',
        reset: true,
        mobile: true,
        distance: '40px',
        easing: 'ease-in-out'
      });
      scrollreveal().reveal('.m-about-us .connect-img', {
        duration: 1200,
        origin: 'bottom',
        reset: true,
        mobile: true,
        distance: '40px',
        easing: 'ease-in-out'
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.m-about-us {
  width: 100%;
  .m-page-banner {
    width: 100%;
    display: block;
    height: 4.5rem;
    background: url('../../assets/images/about_banner.jpg') no-repeat;
    background-position: center top;
    background-size: cover;
  }
  .module-title {
    font-size: .5rem;
    font-weight: 500;
    color: #3E3A39;
    line-height: .48rem;
    text-align: center;
  }
  .m-about-introduce {
    padding: 0 .68rem;
    margin-top: .8rem;
    margin-bottom: 1.1rem;
    .introduce-content {
      font-size: .29rem;
      font-weight: 400;
      color: #595757;
      line-height: .5rem;
      margin-top: .4rem;
      text-align: justify;
      text-indent: 2em;
    }
  }
  .m-about-connect {
    width: 5.7rem;
    margin: 0 auto;
    // margin-top: 1.1rem;
    .connect-content {
      margin-top: .62rem;
      padding-left: .26rem;
      .connect-item {
        display: flex;
        font-size: .29rem;
        font-weight: 500;
        color: #595757;
        line-height: .29rem;
        margin-bottom: .42rem;
        img {
          width: .32rem;
          height: .32rem;
          margin-right: .12rem;
        }
      }
    }
    .connect-img {
      width: 100%;
      height: 1.95rem;
      display: block;
      margin-bottom: 1.42rem;
    }
  }
}
</style>